import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './NoInformationFound.css';

const NoInformationFound = props => (
  props.isFilter ? (
    <div className="no-information-found__filter">
      <p>{props.clearFilterText},</p>
      <span
        role="menuitem"
        tabIndex={0}
        onKeyPress={props.onClear}
        onClick={props.onClear}
      >
        clear filters.
      </span>
    </div>) : (
      <div className="no-information-found__section">
        <h3>{props.titleText}</h3>
        <div>
          <p>{props.subText}</p>
          {props.linkText && <Link to={props.link}>{props.linkText}</Link>}
        </div>
      </div>
  )
);

NoInformationFound.propTypes = {
  linkText: PropTypes.string,
  titleText: PropTypes.string,
  clearFilterText: PropTypes.string,
  subText: PropTypes.string,
  onClear: PropTypes.func,
  link: PropTypes.string,
  isFilter: PropTypes.bool,
};

NoInformationFound.defaultProps = {
  clearFilterText: 'No information was found based on your filter parameters',
  isFilter: false,
  link: '',
};

export default NoInformationFound;



// WEBPACK FOOTER //
// ./src/components/NoInformationFound/NoInformationFound.jsx